export enum AlertType {
  COUNTRY_ALERTS = 'countryAlerts',
  CONFLICTS = 'conflicts',
  HAZARDS = 'hazards',
}
